<template>
  <div class="page-header bg-white d-flex align-items-center p-2">
    <div class="title">
      <h1 class="mb-0" v-if="title">{{title}}</h1>
      <slot v-else name="title"></slot>
    </div>
    <div class="buttons text-right">
      <slot name="buttons"></slot>
    </div>
  </div>
</template>
<script>
  export default {
    name: "PageHeader",
    props: {
      title: {
        type: String,
        required: false
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import "./../../../scss/index";

  .page-header {
    border-radius: 0.4em;

    .title {
      display: inline-flex;
      align-items: center;
      flex: 1;

      h1 {
        font-size: 1.5em;
      }
    }
  }
</style>
